import React from 'react';

import { ITagsTag } from '@r-client/data/graphql-types';
import { Link, Tag } from '@r-client/shared/ui/core';

import styles from './tag-list.module.scss';

export type ITag = Pick<ITagsTag, 'id' | 'displayName' | 'slug' | 'colorHex'>;

export interface ITagListProps {
  tags: ITag[] | null;
  dataTestId?: string;
}

const getTagUrl = ({ slug }: ITag) => `/tag/${slug}`;

export const TagList: React.FC<React.PropsWithChildren<ITagListProps>> = ({
  tags,
  dataTestId,
}) => {
  return (
    <div data-testid={dataTestId}>
      {tags?.map((tag) => {
        const bgColor = tag.colorHex ?? undefined;
        return (
          <Link key={tag.id} href={getTagUrl(tag)}>
            <Tag as="span" bgColor={bgColor} className={styles.tag}>
              {tag.displayName}
            </Tag>
          </Link>
        );
      })}
    </div>
  );
};
